export const GET_MANUFACTURERINVOICE = "GET_MANUFACTURERINVOICE";
export const GET_MANUFACTURERINVOICE_UPDATE = "GET_MANUFACTURERINVOICE_UPDATE";
export const COPY_MANUFACTURERINVOICE = "COPY_MANUFACTURERINVOICE";